exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "mat-dialog-actions {\n  margin-top: 20px; }\n\nmat-dialog-actions:last-child {\n  margin-bottom: unset !important;\n  padding: unset !important; }\n\n@media screen and (max-width: 599px) {\n  mat-dialog-actions button {\n    -ms-flex: 0 1 45%;\n        flex: 0 1 45%; }\n  mat-dialog-actions button:first-child {\n    margin-right: auto; }\n  mat-dialog-actions button:last-child {\n    margin-left: auto; } }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/web_clients/qualicheck.fr/preprod/erp/src/app/core/dialogs/edit-audit-item-dialog/deleted-dialog/delete-dialog.component.scss
// module id = ../../../../../src/app/core/dialogs/edit-audit-item-dialog/deleted-dialog/delete-dialog.component.scss
// module chunks = main